import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { ValueDescription } from '../../../../../card/value-description/value-description';
import Skeleton from '../../../../skeleton';
import { CardTitle } from '../../../../../card/title/card-title';

export const SkeletonDashboardCardsCurrencyImpact: React.FC = observer(() => {
    const { t } = useTranslation();
    return (
        <div className="relative flex h-full flex-col items-start justify-between overflow-hidden rounded-large bg-body p-[1.6rem] shadow-strong lg:p-[2.2rem] max-md:min-h-[13rem] max-md:bg-[url('/images/card-stats/currency-impact-bg.svg')] max-md:bg-[length:8rem] max-md:bg-[position:100%_100%] max-md:bg-no-repeat">
            <CardTitle title={t('layout.statisticsCard.rateImpact.title')} />
            <ValueDescription
                padding={'none'}
                value={<Skeleton height={2.4} />}
                description={<Skeleton height={1.3} />}
                valueColor={'default'}
            />
        </div>
    );
});
